export const resolvePopupDimensionAndPosition = ({ width = 600, height = 720 }) => {
  const left = screen.width / 2 - width / 2
  const top = screen.height / 2 - height / 2
  return `left=${left},top=${top},width=${width},height=${height}`
}
